import type { ApprovedAsset } from '@/types/assets'

/** Shared filter for AssetsPage + AssetLibraryPicker: case-insensitive
 * substring over name, slug, and tags. Empty/whitespace query matches all. */
export function matchesAssetSearch(asset: ApprovedAsset, query: string): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return (
    asset.name.toLowerCase().includes(q) ||
    asset.slug.toLowerCase().includes(q) ||
    asset.tags.some(t => t.toLowerCase().includes(q))
  )
}
